module.exports = {
    routes: {
        '': {
            title: 'Home',
            pageHeader: 'Home',
            className: 'home',
        },
        home: {
            title: 'Home',
            pageHeader: 'Home',
            className: 'home',
        },
        register: {
            title: 'Sign Up',
            className: 'register',
        },
        registerverificationerror: {
            title: 'Register Verification Error',
            className: 'register-verification-error',
        },
        awaitaccountconfirmation: {
            title: 'Account Confirmation',
            className: 'await-account-confirmation',
        },
        accountconfirm: {
            title: 'Account Confirm',
            pageHeader: 'Account Confirm',
            className: 'account-confirm',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Account Confirm', path: '/account-confirm' },
            ],
        },
        passwordexpiring: {
            title: 'Password Expiring',
            className: 'password-expiring',
            loggedInOnly: true,
            currentSection: 'password-expired',
            disableRedirect: 'change-password',
        },
        passwordexpired: {
            title: 'Password Expired',
            className: 'password-expired',
            loggedInOnly: true,
            currentSection: 'password-expired',
            disableRedirect: 'change-password',
        },
        recoverpassword: {
            title: 'Recover Password',
            className: 'recover-password',
        },
        postclaim: {
            title: 'Enter Tickets',
            className: 'post-claim',
            loggedInOnly: true,
            currentSection: 'post-claim',
            disableRedirect: 'survey',
        },
        promotions: {
            title: 'Promotions',
            pageHeader: 'Promotions',
            className: 'promotions',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Promotions', path: '/promotions' },
            ],
        },
        drawings: {
            title: 'Points for Drawings',
            pageHeader: 'Points for Drawings',
            className: 'pointsForDrawings',
            feature: 'pointsForDrawings',
            featureDisabledRedirectPath: '/home',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Points for Drawings', path: '/drawings' },
            ],
        },
        'pointsfordrawingdetails:sweepId': {
            title: '{{PROMOTION_NAME}}',
            pageHeader: '{{PROMOTION_NAME}}',
            className: 'points-for-drawing-details',
            feature: 'pointsForDrawings',
            featureDisabledRedirectPath: '/home',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Points for Drawings', path: '/drawings' },
                { name: '{{PROMOTION_NAME}}', path: '' },
            ],
        },
        secondchancepromotion: {
            title: '{{PROMOTION_NAME}}',
            pageHeader: '{{PROMOTION_NAME}}',
            className: 'second-chance-promotion',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Promotions', path: '/promotions#second-chance-promotions' },
                { name: '{{PROMOTION_NAME}}', path: '' },
            ],
            path: 'promotion',
        },
        promotion: {
            title: '{{PROMOTION_NAME}}',
            pageHeader: '{{PROMOTION_NAME}}',
            className: 'promotion-details',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Promotions/Achievements', path: '/promotions#achievements' },
                { name: '{{PROMOTION_NAME}}', path: '' },
            ],
            path: 'promotion',
        },
        feedback: {
            title: 'Help',
            pageHeader: 'Help',
            className: 'feedback',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Help', path: '/feedback' },
            ],
        },
        myprofile: {
            title: 'My Profile',
            pageHeader: 'My Profile',
            className: 'my-profile',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'My Profile', path: '/my-profile' },
            ],
            loggedInOnly: true,
            currentSection: 'my-profile',
            disableRedirect: 'change-password',
        },
        survey: {
            title: 'Survey',
            pageHeader: 'Survey',
            className: 'survey',
            loggedInOnly: true,
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Survey', path: '/survey' },
            ],
        },
        enter: {
            title: 'Ticket Entry',
            pageHeader: 'Ticket Entry',
            className: 'enter',
            loggedInOnly: true,
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Ticket Entry', path: '/enter' },
            ],
        },
        winners: {
            title: 'Drawings & Winners',
            pageHeader: 'Drawings & Winners',
            className: 'winners',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Drawings & Winners', path: '/winners' },
            ],
        },
        myactivity: {
            title: 'My Activity',
            pageHeader: 'My Activity',

            className: 'my-activity',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'My Activity', path: '/my-activity' },
            ],
            loggedInOnly: true,
        },
        referafriend: {
            title: 'Refer a Friend',
            pageHeader: 'Refer a Friend',
            className: 'refer-a-friend',
            breadcrumb: [
                { name: 'Home', path: '/' },
                { name: 'Refer a Friend', path: '/refer-a-friend' },
            ],
            loggedInOnly: true,
        },
        terms: {
            title: 'Terms of Service',
            className: 'terms',
        },
        updatepassword: {
            title: 'Update Password',
            className: 'update-password',
            loggedInOnly: true,
        },
    },
    title: 'CT Ensemble',
    promotion_id: '',
    jurisdiction: 'CT',
    promotion: 'ensemble_site',
    appUrl: '',
    lottoUrl: '',
    prodhost: '',
    uathost: '',
    feedbackIssueZone: 'SCBZ',
    defaultLoginLink: `/login`,
    drawTicketLength: '19',
    drawFields: [{ name: 'field1', placeholder: 'xxxxxxxxxxxxxxxxxxx', size: '19', value: '' }],
    badTicketInputReplacement: /[o,O]/g, // Regex to remove bad input from ticket fields.
    /*
    Entry Number Format: GGG-BBBBB-X-TTT-XX
    Entry Input: 3 digit game number + 5 digit pack number + 1 digit check digit + 3 digit ticket number + 2 digit check digit
    */
    scratchTicketLengthRegex: '^[0-9]{26}$',
    scratchTicketLength: 26,
    scratchTicketFields: {
        gameNumberFields: [
            {
                name: 'gameNum',
                placeholder: 'GGGG',
                size: '4',
                value: '',
                dataindex: '0',
                side: 'back',
            },
        ],
        fieldGroups: [
            {
                validRanges: [['000', '999']],
                frontNumberFields: [
                    {
                        name: 'validation',
                        placeholder: 'FFFFFFFFF',
                        size: '9',
                        value: '',
                        dataindex: '3',
                        side: 'front',
                    },
                ],
                backNumberFields: [
                    {
                        name: 'packNum',
                        placeholder: 'PPPPP',
                        size: '5',
                        value: '',
                        dataindex: '1',
                        side: 'back',
                    },
                    {
                        name: 'endCheckDigits',
                        placeholder: 'TTTT',
                        size: '3',
                        value: '',
                        dataindex: '2',
                        side: 'back',
                    },
                ],
            },
        ],
    },

    getLoginLink: (app, redirect) => (app && redirect ? `` : '/login'),
    defaultRegisterLink: '/register',
    getRegisterLink: (app, redirect) => (app && redirect ? `` : this.defaultRegisterLink),
    getLogoutDestination: (hostURL, ptaLogout) => (ptaLogout != undefined ? ptaLogout : hostURL + '/home'),
    forgot: '/users/forgot',
    cms_url: 'https://ctensembledev.cms-dev-web1.scientificgames.com',
    cms_cusotomer_url: 'https://ctensemblecustomer.cms-dev-web1.scientificgames.com',
    nyxUrlsUrl: 'https://lottery182205:palottery@www-u69.nyxop.net/api/navigation/level/top',
    resolveCurrency: (name) => {
        const currencyExchange = [
            {
                name: 'sweepstake',
                displayName: 'sweepstake',
                showQuantity: true,
                isPence: false,
                resolve: (amount) => {
                    return amount;
                },
            },
            {
                name: 'lotteryproducts',
                displayName: 'lotteryproducts',
                showQuantity: false,
                isPence: false,
                resolve: () => {
                    return '';
                },
            },
            {
                name: 'promocash',
                displayName: 'promocash',
                showQuantity: true,
                isPence: true,
                resolve: (amount) => {
                    const amt = amount / 100;
                    return new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    }).format(amt);
                },
            },
            {
                name: 'default',
                displayName: 'default',
                showQuantity: true,
                isPence: false,
                resolve: (amount) => {
                    return amount;
                },
            },
        ];

        return currencyExchange.filter((item) => {
            return item.name === name || item.name === 'default';
        })[0];
    },
    pages: [
        {
            url: 'home',
            name: 'Home',
            template: 'content',
        },
        {
            url: 'promotions',
            name: 'Promotions',
            template: 'content',
        },
        {
            url: 'promotion',
            name: 'Promotionpage',
            template: 'content',
        },
        {
            url: 'promotion-mobile',
            name: 'promotion-mobile',
            template: 'content',
        },
        {
            url: 'enter',
            name: 'Enter',
            template: 'content',
        },
        {
            url: 'post-claim',
            name: 'post-claim',
            template: 'content',
        },
        {
            url: 'feedback',
            name: 'Help',
            template: 'content',
        },
        {
            url: 'feedback-mobile',
            name: 'Feedback',
            template: 'content',
        },
        {
            url: 'winners',
            name: 'Drawings & Winners',
            template: 'content',
        },
        {
            url: 'terms',
            name: 'Terms',
            template: 'content',
        },
        {
            url: 'privacy',
            name: 'Privacy',
            template: 'content',
        },
        {
            url: 'legal',
            name: 'Legal Notices',
            template: 'content',
        },
        {
            url: 'login',
            name: 'Log In',
            template: 'content',
        },
        {
            url: 'forgot-password',
            name: 'Forgot Password',
            template: 'content',
        },
        {
            url: 'recover-password',
            name: 'Recover Password',
            template: 'content',
        },
        {
            url: 'password-expiring',
            name: 'Password Expiring',
            template: 'content',
        },
        {
            url: 'password-expired',
            name: 'Password Expired',
            template: 'content',
        },
        {
            url: 'register',
            name: 'Register',
            template: 'content',
        },
        {
            url: 'my-activity',
            name: 'My Activity',
            template: 'content',
        },
        {
            url: 'my-profile',
            name: 'My Profile',
            template: 'content',
        },
        {
            url: 'account-confirm',
            name: 'Account Confirm',
            template: 'content',
        },
    ],
    layout: {
        primary_nav: [
            {
                uri: 'home',
                title: 'HOME',
            },
            {
                uri: 'promotions',
                title: 'PROMOTIONS',
            },
            {
                uri: 'winners',
                title: 'DRAWINGS & WINNERS',
            },
            {
                uri: 'enter',
                title: 'ENTER TICKETS',
            },
            {
                uri: 'my-activity',
                title: 'MY ACTIVITY',
            },
            {
                uri: 'feedback',
                title: 'HELP',
                subMenu: [
                    {
                        title: 'About 2nd Chance',
                        uri: 'feedback',
                        anchor: 'about',
                    },
                    {
                        title: '2nd Chance FAQ',
                        uri: 'feedback',
                        anchor: 'faq',
                    },
                    {
                        title: 'How to Claim',
                        uri: 'feedback',
                        anchor: 'claim',
                    },
                    {
                        title: 'Contact 2nd Chance',
                        uri: 'feedback',
                        anchor: 'contact',
                    },
                    {
                        title: '2nd Chance Official Rules',
                        uri: 'feedback',
                        anchor: 'rules',
                    },
                    {
                        title: 'Terms of Use',
                        uri: 'feedback',
                        anchor: 'terms',
                    },
                    {
                        title: 'Privacy Policy',
                        uri: 'feedback',
                        anchor: 'privacy',
                    },
                ],
            },
        ],
        secondary_nav: [
            {
                uri: 'terms',
                title: 'TERMS OF USE',
            },
            {
                uri: 'privacy',
                title: 'PRIVACY POLICY',
            },
            {
                uri: 'legal',
                title: 'LEGAL NOTICES',
            },
        ],
        mobile_nav: [
            {
                uri: 'home',
                title: 'HOME',
            },
            {
                uri: 'promotions',
                title: 'PROMOTIONS',
            },
            {
                uri: 'enter',
                title: 'ENTER TICKETS',
            },
            {
                uri: 'winners',
                title: 'DRAWINGS & WINNERS',
            },
            {
                uri: 'my-activity',
                title: 'MY ACTIVITY',
            },
            {
                uri: 'feedback',
                title: 'HELP',
            },
        ],
        header: {
            logo: {
                url: 'home',
                src_url: 'ensemble_site_header_logo.png',
                alt: 'Lottery Header Logo',
            },
        },
    },
    apiClientConfig: {
        appUrl: '',
        routes: {
            getConfig: 'ctlEnsemble.getConfig',
            login: 'ctlEnsemble.login',
            logout: 'ctlEnsemble.logout',
            checkTicket: 'ctlEnsemble.checkTicket',
            enterDrawTicket: 'ctlEnsemble.enterTicket',
            enterScratchTicket: 'ctlEnsemble.enterTicket',
            enterFastPlayTicket: 'ctlEnsemble.enterTicket',
            getEntries: 'scbzApi.getEntries',
            getPlayerData: 'ctlEnsemble.getPlayerData',
            setEntryFlashGameFlag: 'scbzApi.setEntryFlashGameFlag',
            update: 'ctlEnsemble.update',
            register: 'ctlEnsemble.register',
            verify: 'ctlEnsemble.verify',
            confirm: 'ctlEnsemble.confirm',
            confirmResend: 'ctlEnsemble.confirmResend',
            winners: 'ctlEnsemble.winners',
            postFeedback: 'ctlEnsemble.postFeedback',
            getFeedbackCategories: 'ctlEnsemble.getFeedbackCategories',
            forgotPassword: 'ctlEnsemble.forgotPassword',
            recoverPassword: 'ctlEnsemble.recoverPassword',
            getGame: 'fauxScbzApi.getGame',
            getGameOver: 'fauxScbzApi.getGameOver',
            getAchievements: 'ctlEnsemble.getAchievements',
            getPoints: 'ctlEnsemble.getPoints',
            getActivity: 'ctlEnsemble.getActivity',
            getReward: 'ctlEnsemble.getReward',
            getPromotions: 'ctlEnsemble.getPromotions',
            getPlayerPromotions: 'ctlEnsemble.getPlayerPromotions',
            getSweeps: 'ctlEnsemble.getSweeps',
            getSweepDetails: 'mrbEnsemble.getSweepDetails',
            allocateEntries: 'mrbEnsemble.allocateEntries',
            getActiveSweeps: 'ctlEnsemble.getActiveSweeps',
            getPlayerAllocatableEntries: 'mrbEnsemble.getPlayerAllocatableEntries',
            getCurrentSweeps: 'ctlEnsemble.getCurrentSweeps',
            getExpiredSweeps: 'ctlEnsemble.getExpiredSweeps',
            getDashboard: 'mrbEnsemble.getDashboard',
            getRevealToken: 'ctlEnsemble.getRevealToken',
            getBanner: 'ctlEnsemble.getBanner',
            expiredDrawings: 'ctlEnsemble.recentDrawings',
            currentDrawings: 'ctlEnsemble.currentDrawings',
            nextDrawings: 'ctlEnsemble.nextDrawings',
            getAllOptins: 'mrbEnsemble.getAllOptins',
            getOptins: 'mrbEnsemble.getOptins',
            getOptinsByCategory: 'mrbEnsemble.getOptinsByCategory',
            optinSubscribe: 'mrbEnsemble.optinSubscribe',
            optinUnsubscribe: 'mrbEnsemble.optinUnsubscribe',
        },
    },
};
